<div class="form-row align-items-center">
    <slot />
</div>